<div class="task-table-scroll-wrapper">
    <table class="task-table">
        <colgroup>
            <col style="width: 48px" />
            <col class="status" />
            <col class="expand" />
            <col class="date" *ngIf="area === WorkflowArea.MANDATE_MANAGEMENT" />
            <col class="user" *ngIf="area === WorkflowArea.MANDATE_MANAGEMENT" />
            <col class="docs" />
            <col class="annotations" />
            <col class="dots" />
        </colgroup>
        <thead>
            <tr>
                <td (click)="$event.stopPropagation()">
                    <span class="bulk-checkbox" hamCheckbox [checked]="sectionToggled" (change)="toggleCheckAll()">
                    </span>
                </td>
                <th>
                    <div class="header-text-container">
                        {{ 'aumico_pm_tasks_status_table_header' | i18next }}
                    </div>
                </th>
                <th class="expand-col">
                    <div class="header-text-container">
                        {{ 'aumico_pm_tasks_task_table_header' | i18next }}
                    </div>
                </th>
                <th *ngIf="area === WorkflowArea.MANDATE_MANAGEMENT">
                    <div class="header-text-container">
                        {{ 'aumico_pm_tasks_due_date_table_header' | i18next }}
                    </div>
                </th>
                <th *ngIf="area === WorkflowArea.MANDATE_MANAGEMENT">
                    <div class="header-text-container">
                        {{ 'aumico_pm_tasks_responsible_table_header' | i18next }}
                    </div>
                </th>
                <th>
                    <div class="header-text-container">{{ 'aumico_ui_documents' | i18next }}</div>
                </th>
                <th class="expand-col">
                    <div class="header-text-container">{{ 'aumico_ui_annotations' | i18next }}</div>
                </th>
                <th>&nbsp;</th>
            </tr>
        </thead>
        <tbody>
            <ng-container>
                <!-- Existing Tasks -->
                <tr
                    *ngFor="let task of tasks"
                    class="task-row"
                    data-testid="mm-task"
                    [attr.data-description]="task.description"
                    [ngClass]="getTaskStateClass(task.taskState)"
                    [class.selected]="selectedTaskIds.has(task.id)"
                >
                    <td (click)="onTaskCheckboxClick(task, $event)">
                        <span
                            class="bulk-checkbox"
                            [checked]="selectedTaskIds.has(task.id)"
                            hamCheckbox
                            [bubbleEvents]="true"
                        >
                        </span>
                    </td>
                    <!-- STATUS -->
                    <td>
                        <!-- Closing Process Checkbox -->
                        <ng-container *ngIf="area === WorkflowArea.CLOSING_PROCESS">
                            <ng-container *ngIf="task.taskState === TaskState.NOT_APPLICABLE">
                                <div class="ham-badge-n-a" hamBadge color="grey" size="small">
                                    {{ 'aumico_ui_not_applicable' | i18next }}
                                </div>
                            </ng-container>
                            <ng-container *ngIf="task.taskState !== TaskState.NOT_APPLICABLE">
                                <div
                                    class="closing-checkbox"
                                    hamCheckbox
                                    [checked]="task.taskState === TaskState.DONE"
                                    (change)="onClosingTaskStatusChange(task, $event.checked)"
                                ></div>
                            </ng-container>
                        </ng-container>

                        <!-- Mandate Management Status Dropdown -->
                        <ng-container *ngIf="area === WorkflowArea.MANDATE_MANAGEMENT">
                            <ng-container *ngIf="task.taskState === TaskState.NOT_APPLICABLE">
                                <div class="ham-badge-n-a" hamBadge color="grey" size="small">
                                    {{ 'aumico_ui_not_applicable' | i18next }}
                                </div>
                            </ng-container>
                            <ng-container *ngIf="task.taskState !== TaskState.NOT_APPLICABLE">
                                <ham-badge-button
                                    #statusButtonWrapper
                                    class="status-button"
                                    [ngClass]="{
                                        'not-started': task.taskState === TaskState.OPEN,
                                        'in-progress': task.taskState === TaskState.IN_PROGRESS,
                                        'in-review': task.taskState === TaskState.IN_REVIEW,
                                        completed: task.taskState === TaskState.DONE
                                    }"
                                    [variant]="task.taskState === TaskState.DONE ? 'green' : 'white'"
                                    (click)="openStatusFlyout(task.id, statusButtonWrapper)"
                                >
                                    <span class="inner-status-wrapper">
                                        {{ getStatusLabel(task.taskState) }}
                                        <span class="ham-icon">
                                            <i class="chevron-down-icon"></i>
                                        </span>
                                    </span>
                                </ham-badge-button>

                                <div class="dropdown-wrapper">
                                    <span
                                        class="menu-flyout"
                                        hamFlyout
                                        *ngIf="openedStatusFlyoutTaskId === task.id"
                                        [position]="flyoutPosition"
                                        (closeFlyout)="closeStatusFlyout()"
                                    >
                                        <div class="flyout-content">
                                            <div
                                                class="status-option"
                                                *ngFor="let option of statusOptions"
                                                (click)="updateStatus(task, option.value)"
                                            >
                                                {{ option.label }}
                                            </div>
                                        </div>
                                    </span>
                                </div>
                            </ng-container>
                        </ng-container>
                    </td>

                    <!-- TASK DESCRIPTION -->
                    <td class="task-description expand-col" [class.completed]="task.taskState === 100">
                        <span class="task-description" *ngIf="!task.isEditing">{{ task.description }}</span>
                        <div class="task-edit-wrapper">
                            <input
                                #taskInput
                                class="task-edit-input"
                                *ngIf="task.isEditing"
                                type="text"
                                [value]="task.description"
                                (blur)="finishEditing(task, $event)"
                                (keydown.enter)="finishEditing(task, $event)"
                                (keydown.escape)="cancelEditing(task)"
                            />
                        </div>
                    </td>

                    <!-- DUE DATE -->
                    <td *ngIf="area === WorkflowArea.MANDATE_MANAGEMENT">
                        <div class="dropdown-wrapper">
                            <ham-button
                                #dueDateButtonWrapper
                                class="date-button"
                                data-testid="mm-task-due"
                                [class.overdue]="isOverdue(task.dueDate)"
                                [class.due-soon]="isDueSoon(task.dueDate)"
                                [class.completed]="task.taskState === 100"
                                size="xs"
                                variant="white"
                                rightIcon="assets/hamIcons/calendar-month-outline.svg"
                                (buttonClick)="openDueDateFlyout(task.id, dueDateButtonWrapper)"
                                [disabled]="task.taskState === TaskState.NOT_APPLICABLE"
                            >
                                {{ task.dueDate | dateLocale }}
                            </ham-button>
                        </div>

                        <span
                            class="menu-flyout due-date-flyout"
                            hamFlyout
                            *ngIf="openedDueDateFlyoutTaskId === task.id"
                            [position]="flyoutPosition"
                            (closeFlyout)="closeDueDateFlyout()"
                        >
                            <div class="flyout-content">
                                <div class="custom-datepicker-wrapper">
                                    <mat-calendar
                                        [selected]="calendarSelectedDate"
                                        (selectedChange)="updateDueDate(task, $event)"
                                    ></mat-calendar>

                                    <div class="datepicker-actions-pm-tasks">
                                        <ham-button variant="teal" size="sm" (buttonClick)="selectToday(task)">
                                            {{ 'aumico_pm_tasks_select_date_today' | i18next }}
                                        </ham-button>
                                    </div>
                                </div>
                            </div>
                        </span>
                    </td>

                    <!-- ASSIGNEE -->
                    <td *ngIf="area === WorkflowArea.MANDATE_MANAGEMENT">
                        <div class="dropdown-wrapper assignee">
                            <ham-button
                                #assigneeButtonWrapper
                                class="assignee-button"
                                data-testid="mm-task-assignee"
                                [attr.data-assignee]="getAssigneeName(task.assignedTo)"
                                size="xs"
                                variant="plain"
                                rightIcon="assets/hamIcons/chevron-down.svg"
                                (buttonClick)="openAssigneeFlyout(task.id, assigneeButtonWrapper)"
                                [disabled]="task.taskState === TaskState.NOT_APPLICABLE"
                            >
                                <span class="avatar" [class.deleted]="isUserDeleted(task.assignedTo)">{{ getInitials(getAssigneeName(task.assignedTo)) }}</span>
                            </ham-button>
                        </div>

                        <span
                            class="menu-flyout assignee-flyout"
                            hamFlyout
                            *ngIf="openedAssigneeFlyoutTaskId === task.id"
                            [position]="flyoutPosition"
                            (closeFlyout)="closeAssigneeFlyout()"
                        >
                            <div class="flyout-user-options-content">
                                <div
                                    *ngFor="let assignee of getSortedAssigneeOptions(task)"
                                    class="status-option assignee"
                                    [class.selected]="task.assignedTo === assignee.id"
                                    (click)="updateAssignee(task, assignee.id)"
                                >
                                    <span class="avatar">{{ getInitials(assignee.name) }}</span>
                                    <span class="name">{{ assignee.name }}</span>
                                </div>
                            </div>
                        </span>
                    </td>
                    <!-- TASK DOCUMENTS -->
                    <td class="task-documents">
                        <app-documents
                            [expirationDate]="documentExpirationDate"
                            [documents]="getDocumentsForTask(task)"
                            [documentsInProgressUpload]="documentsInProgressUpload[task.id] || []"
                            [currentUserId]="currentUserId"
                            [projectId]="task.projectId"
                            [taskId]="task.id"
                            (onDocumentRemoved)="onDocumentRemoved($event)"
                            (onDocumentAdded)="onDocumentsAdded($event)"
                            (onDocumentsAddedInProgress)="onDocumentsAddedInProgress(task.id, $event)"
                            (openFile)="onOpenFile($event)"
                            (downloadFile)="onDownloadFile($event.fileId, $event.documentName)"
                            [disabled]="task.taskState === TaskState.NOT_APPLICABLE"
                            (startPolling)="onStartPolling($event)"
                            (stopPolling)="onStopPolling($event)"
                        >
                        </app-documents>
                    </td>

                    <!-- TASK ANNOTATION -->
                    <td class="task-annotion expand-col">
                        <app-annotations
                            [annotations]="annotationsMap[task.id] || []"
                            [currentUserId]="currentUserId"
                            [projectId]="task.projectId"
                            [taskId]="task.id"
                            [taskName]="task.description"
                            [workflowArea]="task.area"
                            [users]="assigneeOptions"
                            (onAnnotationAdded)="onAnnotationAdded(task.id, $event)"
                            (onAnnotationChanged)="onAnnotationChanged($event.id, $event)"
                            (onAnnotationRemoved)="onAnnotationRemoved($event.id)"
                            [disabled]="task.taskState === TaskState.NOT_APPLICABLE"
                        ></app-annotations>
                    </td>
                    <!-- TASK OPTIONS -->
                    <td class="task-options">
                        <span
                            #optionsButtonWrapper
                            hamIconShapes
                            class="icon"
                            icon="assets/hamIcons/dots-horizontal.svg"
                            [variant]="'transparent'"
                            [size]="'regular'"
                            (click)="toggleOptionsMenu($event, task.id, optionsButtonWrapper)"
                        ></span>
                        <span
                            class="task-options-flyout menu-flyout"
                            *ngIf="openedOptionsMenuTaskId === task.id"
                            hamFlyout
                            [position]="flyoutPosition"
                            (closeFlyout)="closeOptionsMenu()"
                        >
                            <div class="flyout-content">
                                <div
                                    class="task-option-item"
                                    (click)="startEditing(task); $event.stopPropagation()"
                                    [class.disabled]="task.taskState === TaskState.NOT_APPLICABLE"
                                >
                                    <span
                                        hamIconShapes
                                        icon="assets/hamIcons/pen-outline.svg"
                                        [variant]="'transparent'"
                                        [size]="'s'"
                                    ></span>
                                    <span>{{
                                        'aumico_pm_tasks_rename_task' | i18next : { defaultValue: 'Rename Task' }
                                    }}</span>
                                </div>
                                <div
                                    class="task-option-item"
                                    *ngIf="task.taskState !== TaskState.NOT_APPLICABLE"
                                    (click)="onMarkTaskNotApplicable(task.id); $event.stopPropagation()"
                                >
                                    <span
                                        hamIconShapes
                                        icon="assets/hamIcons/archive-outline.svg"
                                        [variant]="'transparent'"
                                        [size]="'s'"
                                    ></span>
                                    <span>{{
                                        'aumico_pm_tasks_not_applicable'
                                            | i18next : { defaultValue: 'Not Applicable for this Mandate' }
                                    }}</span>
                                </div>
                                <div
                                    class="task-option-item"
                                    *ngIf="task.taskState === TaskState.NOT_APPLICABLE"
                                    (click)="onMarkTaskApplicable(task.id); $event.stopPropagation()"
                                >
                                    <span
                                        hamIconShapes
                                        icon="assets/hamIcons/archive-outline.svg"
                                        [variant]="'transparent'"
                                        [size]="'s'"
                                    ></span>
                                    <span>{{
                                        'aumico_pm_tasks_mark_applicable'
                                            | i18next : { defaultValue: 'Applicable for this Mandate' }
                                    }}</span>
                                </div>
                                <div
                                    class="task-option-item"
                                    (click)="onDeleteTask(task); $event.stopPropagation(); $event.preventDefault()"
                                    [class.disabled]="task.taskState === TaskState.NOT_APPLICABLE"
                                >
                                    <span
                                        hamIconShapes
                                        icon="assets/hamIcons/trash-outline.svg"
                                        [variant]="'red-transparent'"
                                        [size]="'s'"
                                    ></span>
                                    <span>{{
                                        'aumico_pm_tasks_delete' | i18next : { defaultValue: 'Delete Task' }
                                    }}</span>
                                </div>
                            </div>
                        </span>
                    </td>
                </tr>
                <!-- New Task Row (inline form) at the end -->
                <tr *ngIf="newTaskRow.isActive" class="task-row NEW">
                    <td></td>
                    <td>
                        <div class="dropdown-wrapper">
                            <span class="ham-badge" hamBadge color="grey" size="small">{{
                                'aumico_pm_tasks_status_open' | i18next
                            }}</span>
                        </div>
                    </td>
                    <td class="task-description expand-col">
                        <div class="task-edit-wrapper">
                            <input
                                id="new-task-desc-input"
                                type="text"
                                [(ngModel)]="newTaskRow.description"
                                (keydown.enter)="onNewTaskDescriptionBlurOrEnter($event, newTaskRow.sectionId)"
                                (blur)="onNewTaskDescriptionBlurOrEnter($event, newTaskRow.sectionId)"
                                placeholder="Enter task description..."
                            />
                        </div>
                    </td>
                    <td *ngIf="area === WorkflowArea.MANDATE_MANAGEMENT">
                        <div class="dropdown-wrapper">
                            <span class="ham-badge" hamBadge color="grey" size="small">{{
                                newTaskRow.dueDate | dateLocale
                            }}</span>
                        </div>
                    </td>
                    <td *ngIf="area === WorkflowArea.MANDATE_MANAGEMENT">
                        <div class="dropdown-wrapper assignee">
                            <span class="avatar">{{ getInitials(getAssigneeName(newTaskRow.assignedTo)) }}</span>
                        </div>
                    </td>
                    <td class="task-annotion"></td>
                    <td class="task-annotion expand-col"></td>
                    <td class="task-options"></td>
                </tr>
            </ng-container>
        </tbody>
    </table>
    <ham-button
        [outline]="true"
        size="xs"
        icon="assets/hamIcons/plus-outline.svg"
        data-testid="mm-add-task"
        (buttonClick)="onNewTask(sectionId, area, taskType)"
        class="add-task-button"
    >
        {{ 'aumico_ui_new_task' | i18next }}
    </ham-button>
</div>

<ham-confirm-decline-modal
    *ngIf="showDeleteModal"
    (cancel)="cancelDeleteTask()"
    (action)="confirmDeleteTask()"
    footerAlignment="center"
    actionBtnText="{{ 'aumico_button_delete' | i18next }}"
    noActionBtnText="{{ 'aumico_button_cancel' | i18next }}"
>
    <ham-general-confirm-decline-modal-body
        [text]="
            'aumico_app_cpmm_task_delete_confirmation'
                | i18next : { task: getTruncatedContent(taskToDelete?.description) }
        "
    ></ham-general-confirm-decline-modal-body>
</ham-confirm-decline-modal>
